export default __webpack_public_path__ + "static/media/Home_IMG-02.988f75ac.png";